export default function (props: any) {
    return (
        <svg width="1.35em" height="1em" viewBox="0 0 23 17" stroke="#666666" xmlns="http://www.w3.org/2000/svg">
            <g strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1310.000000, -660.000000)" strokeWidth="1.62">
                    <g transform="translate(0.000000, 60.000000)">
                        <g transform="translate(1128.000000, 540.996536)">
                            <g transform="translate(84.000000, 58.999622)">
                                <g transform="translate(98.934389, 0.000000)">
                                    <path d="M18.5108311,0.81 C18.8923019,0.81 19.2473232,0.923052587 19.5443342,1.1174091 L19.5443342,1.1174091 L11.9351512,8.65019074 C11.5668847,9.01479433 11.0861501,9.19709613 10.6054156,9.19709613 C10.124681,9.19709613 9.64394645,9.01479433 9.27571416,8.65022463 L9.27571416,8.65022463 L1.66747813,1.11676744 C1.96428972,0.922803783 2.31894923,0.81 2.7,0.81 L2.7,0.81 Z"></path>
                                    <rect x="0.81" y="0.81" width="19.5908311" height="14.3850199" rx="2.7"></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
